// Action type constants
export const GET_CONTACTS = {
  START: "GET_CONTACTS_START",
  SUCCESS: "GET_CONTACTS_SUCCESS",
  ERROR: "GET_CONTACTS_ERROR",
};

export const CREATE_CONTACT = {
  START: "CREATE_CONTACT_START",
  SUCCESS: "CREATE_CONTACT_SUCCESS",
  ERROR: "CREATE_CONTACT_ERROR",
};

export const UPDATE_CONTACT = {
  START: "UPDATE_CONTACT_START",
  SUCCESS: "UPDATE_CONTACT_SUCCESS",
  ERROR: "UPDATE_CONTACT_ERROR",
};

export const DELETE_CONTACT = {
  START: "DELETE_CONTACT_START",
  SUCCESS: "DELETE_CONTACT_SUCCESS",
  ERROR: "DELETE_CONTACT_ERROR",
};

export const TOGGLE_FAVORITE = {
  START: "TOGGLE_FAVORITE_START",
  SUCCESS: "TOGGLE_FAVORITE_SUCCESS",
  ERROR: "TOGGLE_FAVORITE_ERROR",
};

export const IMPORT_CONTACTS = {
  START: "IMPORT_CONTACTS_START",
  SUCCESS: "IMPORT_CONTACTS_SUCCESS",
  ERROR: "IMPORT_CONTACTS_ERROR",
};

export const BULK_DELETE_CONTACTS = {
  START: "BULK_DELETE_CONTACTS_START",
  SUCCESS: "BULK_DELETE_CONTACTS_SUCCESS",
  ERROR: "BULK_DELETE_CONTACTS_ERROR",
};

export const SEARCH_CONTACTS = {
  START: "SEARCH_CONTACTS_START",
  SUCCESS: "SEARCH_CONTACTS_SUCCESS",
  ERROR: "SEARCH_CONTACTS_ERROR",
};

export const GET_FAVORITES = {
  START: "GET_FAVORITES_START",
  SUCCESS: "GET_FAVORITES_SUCCESS",
  ERROR: "GET_FAVORITES_ERROR",
};

// Default state sections
const defaultGetContactsState = {
  getContactsLoading: false,
  getContactsData: null,
  getContactsError: false,
};

const defaultCreateContactState = {
  createContactLoading: false,
  createContactData: false,
  createContactError: false,
};

const defaultUpdateContactState = {
  updateContactLoading: false,
  updateContactData: false,
  updateContactError: false,
};

const defaultDeleteContactState = {
  deleteContactLoading: false,
  deleteContactData: false,
  deleteContactError: false,
};

const defaultToggleFavoriteState = {
  toggleFavoriteLoading: false,
  toggleFavoriteData: false,
  toggleFavoriteError: false,
};

const defaultImportContactsState = {
  importContactsLoading: false,
  importContactsData: false,
  importContactsError: false,
};

const defaultBulkDeleteState = {
  bulkDeleteLoading: false,
  bulkDeleteData: false,
  bulkDeleteError: false,
};

const defaultSearchContactsState = {
  searchContactsLoading: false,
  searchContactsData: [],
  searchContactsError: false,
};

const defaultGetFavoritesState = {
  getFavoritesLoading: false,
  getFavoritesData: null,
  getFavoritesError: false,
};

// Combined default state
export const defaultState = {
  ...defaultGetContactsState,
  ...defaultCreateContactState,
  ...defaultUpdateContactState,
  ...defaultDeleteContactState,
  ...defaultToggleFavoriteState,
  ...defaultImportContactsState,
  ...defaultBulkDeleteState,
  ...defaultSearchContactsState,
  ...defaultGetFavoritesState,
};

// Event constants
export const EVENTS = {
  GET_CONTACTS: "GET_CONTACTS",
  CREATE_CONTACT: "CREATE_CONTACT",
  UPDATE_CONTACT: "UPDATE_CONTACT",
  DELETE_CONTACT: "DELETE_CONTACT",
  TOGGLE_FAVORITE: "TOGGLE_FAVORITE",
  IMPORT_CONTACTS: "IMPORT_CONTACTS",
  SEARCH_CONTACTS: "SEARCH_CONTACTS",
  RESET_ADDRESS_BOOK_REDUCER: "RESET_ADDRESS_BOOK_REDUCER",
  RESET_CREATE_CONTACT: "RESET_CREATE_CONTACT",
  RESET_UPDATE_CONTACT: "RESET_UPDATE_CONTACT",
  RESET_DELETE_CONTACT: "RESET_DELETE_CONTACT",
  RESET_IMPORT_CONTACTS: "RESET_IMPORT_CONTACTS",
  BULK_DELETE_CONTACTS: "BULK_DELETE_CONTACTS",
  RESET_BULK_DELETE: "RESET_BULK_DELETE",
  GET_FAVORITES: "GET_FAVORITES",
};

const addressBookReducer = (state = defaultState, action = {}) => {
  switch (action.event) {
    case EVENTS.RESET_ADDRESS_BOOK_REDUCER:
      return defaultState;

    case EVENTS.RESET_CREATE_CONTACT:
      return {
        ...state,
        ...defaultCreateContactState,
      };

    case EVENTS.RESET_UPDATE_CONTACT:
      return {
        ...state,
        ...defaultUpdateContactState,
      };

    case EVENTS.RESET_DELETE_CONTACT:
      return {
        ...state,
        ...defaultDeleteContactState,
      };

    case EVENTS.RESET_IMPORT_CONTACTS:
      return {
        ...state,
        ...defaultImportContactsState,
      };

    case EVENTS.RESET_BULK_DELETE:
      return {
        ...state,
        ...defaultBulkDeleteState,
      };

    case EVENTS.GET_CONTACTS:
      return {
        ...state,
        getContactsLoading: action.type === GET_CONTACTS.START,
        getContactsData:
          action.type === GET_CONTACTS.SUCCESS ? action.payload : state.getContactsData,
        getContactsError:
          action.type === GET_CONTACTS.ERROR ? action.payload : false,
      };

    case EVENTS.CREATE_CONTACT:
      return {
        ...state,
        createContactLoading: action.type === CREATE_CONTACT.START,
        createContactData:
          action.type === CREATE_CONTACT.SUCCESS ? action.payload : false,
        createContactError:
          action.type === CREATE_CONTACT.ERROR ? action.payload : false,
      };

    case EVENTS.UPDATE_CONTACT:
      return {
        ...state,
        updateContactLoading: action.type === UPDATE_CONTACT.START,
        updateContactData:
          action.type === UPDATE_CONTACT.SUCCESS ? action.payload : false,
        updateContactError:
          action.type === UPDATE_CONTACT.ERROR ? action.payload : false,
      };

    case EVENTS.DELETE_CONTACT:
      return {
        ...state,
        deleteContactLoading: action.type === DELETE_CONTACT.START,
        deleteContactData:
          action.type === DELETE_CONTACT.SUCCESS ? action.payload : false,
        deleteContactError:
          action.type === DELETE_CONTACT.ERROR ? action.payload : false,
      };

    case EVENTS.TOGGLE_FAVORITE:
      return {
        ...state,
        toggleFavoriteLoading: action.type === TOGGLE_FAVORITE.START,
        toggleFavoriteData:
          action.type === TOGGLE_FAVORITE.SUCCESS ? action.payload : false,
        toggleFavoriteError:
          action.type === TOGGLE_FAVORITE.ERROR ? action.payload : false,
      };

    case EVENTS.IMPORT_CONTACTS:
      return {
        ...state,
        importContactsLoading: action.type === IMPORT_CONTACTS.START,
        importContactsData:
          action.type === IMPORT_CONTACTS.SUCCESS ? action.payload : false,
        importContactsError:
          action.type === IMPORT_CONTACTS.ERROR ? action.payload : false,
      };

    case EVENTS.BULK_DELETE_CONTACTS:
      return {
        ...state,
        bulkDeleteLoading: action.type === BULK_DELETE_CONTACTS.START,
        bulkDeleteData:
          action.type === BULK_DELETE_CONTACTS.SUCCESS ? action.payload : false,
        bulkDeleteError:
          action.type === BULK_DELETE_CONTACTS.ERROR ? action.payload : false,
      };

    case EVENTS.SEARCH_CONTACTS:
      return {
        ...state,
        searchContactsLoading: action.type === SEARCH_CONTACTS.START,
        searchContactsData:
          action.type === SEARCH_CONTACTS.SUCCESS ? action.payload : [],
        searchContactsError:
          action.type === SEARCH_CONTACTS.ERROR ? action.payload : false,
      };

    case EVENTS.GET_FAVORITES:
      return {
        ...state,
        getFavoritesLoading: action.type === GET_FAVORITES.START,
        getFavoritesData:
          action.type === GET_FAVORITES.SUCCESS ? action.payload : state.getFavoritesData,
        getFavoritesError:
          action.type === GET_FAVORITES.ERROR ? action.payload : false,
      };

    default:
      return state;
  }
};

export default addressBookReducer;
